import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import VueKonva from 'vue-konva'
import App from './App.vue'
import { createI18n } from 'vue-i18n'
import en from '@/lang/en.json'
import da from '@/lang/dk.json'
import type Konva from 'konva'
import type Jquery from 'jquery'

let curStoreId = 'en'
if (
  window.checkout !== undefined &&
  window.checkout.storeId !== undefined &&
  window.checkout.storeId === '1'
) {
  curStoreId = 'da'
}
const i18n = createI18n({
  legacy: false,
  locale: curStoreId,
  fallbackLocale: curStoreId,
  messages: { en, da },
})
const app = createApp(App)
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
app.use(pinia)
app.use(i18n)
app.use(VueKonva, { prefix: 'Konva' })

app.mount('#app')

declare global {
  interface Window {
    BASE_URL: string
    _priceUtils?: {
      formatPriceLocale: (amount: number, format?: string, isShowSign?:boolean) => string
    }
    Itoris?: {
      PriceFormula?: {
        finalPrice: number
        priceFormulaTaxInfo: {
          taxRate: string
          priceAlreadyIncludesTax: number,
          displayPriceMode: number
        }
      }
    }
    Konva: typeof Konva
    jQuery: typeof Jquery
    cushionFinalImageUrl: string
    renderpath: string
    imgpath: string
    checkout: {
      storeId: string
      checkoutUrl: string & Location
    }
  }
}
